import styles from './externalLink.module.css';

export default function ExternalLink ({ href, children, ...props }) {
  return (
    <a
      href={href}
      className={styles.linkText}
      target='_blank'
      rel='noopener noreferrer'
      {...props}
    >
      {children}
    </a>
  );
}
